<template>
  <div class="incoming-call-banner">
    <p class="text">You have an ongoing call from {{ formattedDrName }}</p>

    <div class="buttons">
      <smd-btn class="accept-btn" clean @click="emitAccept">Join</smd-btn>
      <smd-btn class="later-btn" clean @click="emitLaterPress">Later</smd-btn>
    </div>

  </div>
</template>

<script>
  export default {
    name: "BannerIncomingCall",
    props: {
      doctor: {type: Object, required: true},
    },
    computed: {
      formattedDrName() {
        return `Dr. ${this.doctor.name}`;
      }
    },
    methods: {
      emitAccept() {
        this.$emit('call-accept');
      },
      emitLaterPress() {
        this.$emit('call-later-pressed');
      }
    }
  }
</script>

<style lang="scss">
  .incoming-call-banner {
    background-color: color(green, messenger);
    display: inline-flex;
    padding: space(s) space(m);
    justify-content: center;
    flex-wrap: wrap;
    color: color(white, brand);
    border-radius: radius(medium);
    @include box-shadow(shadow);

    .text {
      @include space-me($prop: margin, $r: s);
      align-self: center;

      @include responsive(mobile) {
        padding: space(xs);
      }
    }

    button {
      @include font-style(Body1);

      &.accept-btn, .accept-btn:hover {
        color: color(white, brand);
      }

      &.later-btn, .later-btn:hover {
        color: color(dark, brand);
      }
    }
  }
</style>